<template>

<div id="app">
  <navbar/>
  <router-view/>
</div>

</template>

<script>

import Navbar from '@/components/Navbar'

export default {
  name: 'App',
  components: {Navbar}
}

</script>

<style src="vue-multiselect/dist/vue-multiselect.min.css"></style>
<style lang="scss">

$theme-colors: (dark: #5A4099);

@import '~bootstrap/scss/bootstrap';
@import 'bootstrap-vue/dist/bootstrap-vue.css';
@import '@deveodk/vue-toastr/dist/@deveodk/vue-toastr.css';
@import '../node_modules/vue-datetime/dist/vue-datetime.min.css';

.page-container {
  max-height: calc(100vh - 60px);
  display: flex;
  flex-direction: column;
  padding-bottom: 10px;

  .header-container {
    padding-top: 10px;
    padding-left: 10px;
    flex: 0 0 auto;
  }

  .body-container {
    flex: 0 1 auto;
    overflow-y: auto;
  }
}

.filter-form {
  display: flex;
  align-items: center;
  flex-wrap: wrap;
  >div {
    margin-left: 10px;
  }
}

.items-gap {
  >div {
    margin-left: 10px;
  }
}

div.v-select {
  min-width: 200px;
  .selected-tag {
    padding-right: 3rem;
  }
}

.form-row label, .form-group label { // This allows me to put inputs inside labels so I can skip the label's 'for' attribute
  display: block;
}

.input-group-text {
  padding-right: 0.3rem;
  padding-left: 0.3rem;
}

.modal-xl {
  @media (min-width: 992px) {
    max-width: 900px;
  }
}

.modal-block {
  margin-bottom: 1rem;
  padding-bottom: 1rem;
  border-bottom: 1px solid #d3d3d3;

  &:not(.bordered):last-child {
    border-bottom: none;
  }
  &.borderless {
    border-bottom: none;
  }
}

.modal-block-title {
  text-align: center;
  font-weight: bold;
  margin-bottom: .3rem;
}

.flex-100 {
  flex: 1 0 0 !important;
}

.fixed-table-container {
  height: calc(100vh - 350px);
  overflow-x: auto;
  overflow-y: hidden;

  table {
    display: flex;
    flex-flow: column;
    height: 100%;
    width: 100%;
    min-width: 1600px;
  }
  table thead {
    /* head takes the height it requires,
    and it's not scaled when table is resized */
    flex: 0 0 auto;
    width: calc(100% - 0.9em);
  }
  table tbody {
    /* body takes all the remaining available space */
    flex: 1 1 auto;
    display: block;
    overflow-y: scroll;
  }
  table tbody tr {
    width: 100%;
  }
  table thead, table tbody tr {
    display: table;
    table-layout: fixed;
  }
}

</style>



// WEBPACK FOOTER //
// src/App.vue